import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import Input from '../../Input';
import styles from './styles.less';

const Phone = ({ t, phone, setValue }) => (
  <>
    <WizardInput title={t('course.create.wizard.step5_3')} hint={t('wizard.hint.phone')}>
      <Input
        version="long"
        size="large"
        value={phone}
        onChange={e => setValue(e.target.value, 'phone')}
        placeholder={t('wizard.phone.number')}
        className={styles.phoneNumber}
        name="wizard_input_phone_number"
      />
    </WizardInput>
  </>
);

Phone.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  phone: PropTypes.string,
};

Phone.defaultProps = {
  setValue: () => {},
  t: () => {},
  phone: '',
};

export default Phone;
